import { motion } from "framer-motion";

export const easeLux = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 34, className = "", once = true, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, amount: 0.25 }}
    transition={{ duration: 0.9, ease: easeLux, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

// Line-by-line masked reveal for headings
export const MaskLines = ({ lines, className = "", delay = 0, active = true }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="mask-line">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={active ? { y: "0%" } : { y: "110%" }}
          transition={{ duration: 1.1, ease: easeLux, delay: delay + i * 0.12 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);
